<template>
	<div>
		<div class='a-comparison'>
			<div class="app-container a-comparison-container">
				<div class="a-comparison-header">
					<div class="row align-items-center">
						<div class='col-auto a-comparison-back'>
							<div class='a-comparison-back-text' @click='backPage'>
								<v-icon icon='arrow-prev' size='10' />
								{{$t('account.comparison.back_to_search')}}
							</div>
						</div>
						<div class="col">
							<p class='a-heading-1'>{{$t('account.comparison.title.flights')}} {{comparison.count ? `(${comparison.count} ${$t('account.with')} ${comparison.maxCount})` : ""}}</p>
						</div>
						<a-comparison-action :filename="`${$t('account.comparison.title.flights')} ${comparison.count ? `(${comparison.count} ${$t('account.with')} ${comparison.maxCount})` : ''}`" :link="copyLink">
							<template v-slot:share>
								<section class="pdf-item">
									<p class='a-pdf-text'>{{$t('account.trips.prices_are_for_reference_only')}} <span class='a-pdf-date'>{{$moment().format("DD/MM/YYYY HH:MM")}}</span></p>
									<p class='a-pdf-title'>{{$t('account.comparison.title.flights')}} {{comparison.count ? `(${comparison.count} ${$t('account.with')} ${comparison.maxCount})` : ""}}</p>
									<p class='a-pdf-sub-title' v-if='comparison.searchData'>
										{{$moment($_.head(comparison.searchData.directions).dateFrom).format("DD/MM/YYYY")}}
										{{comparison.searchData.type === "both" ? " - " + $moment($_.head(comparison.searchData.directions).dateTo).format("DD/MM/YYYY") : null}}
										{{comparison.searchData.type === "complex_route" ? " - " + $moment($_.last(comparison.searchData.directions).dateFrom).format("DD/MM/YYYY") : null}}
									</p>
								</section>

								<section class='pdf-item' v-for='(item, i) in items' :key='i'>
									<div class="a-timeline-wrap">
										<a-card-flights
											:item='item'
											:searchData='comparison.searchData'
										/>
									</div>
								</section>
							</template>
						</a-comparison-action>
					</div>
				</div>

				<template v-if='items.length > 0'>
					<div v-for='(item, i) in items' :key='i'>
						<trips-card
							:item='item'
							:check_availability='check_availability'
							@update-comparison='check_availability = $event, comparison = $event'
							@open-details='openDetails(item)'
							@open-offer='openOffer(item)'
							:hideCheckbox='true'
						/>
					</div>
				</template>

				<template v-else>
					<trips-preloader
						name='flights'
						animation='flights'
						:title='$t("account.search.preloader.flights.no_found")'
					/>
				</template>
			</div>
		</div>

		<trips-card-details v-model='card_details' :card='active_card' @open-offer='openOffer(active_card)' />
	</div>
</template>

<script>
	import TripsPreloader from '@/views/account/search/components/preloader';
	import TripsCard from '@/views/account/search/flights/card';
	import TripsCardDetails from '@/views/account/details/flights';
	import { getComparison, comparisonCheckAvailability } from '@/services/request';
	import AComparisonAction from '@/views/account/comparison/components/action';
	import ACardFlights from '@/views/account/comparison/pdf-card/flights';

	export default {
		data: () => ({
			comparison: {},
			check_availability: {},
			active_card: null,
			card_details: false
		}),
		components: {
			TripsPreloader,
			TripsCard,
			TripsCardDetails,
			AComparisonAction,
			ACardFlights
		},
		computed: {
			items() {
				return this.comparison.items ? Object.values(this.comparison.items) : [];
			},
			copyLink() {
				return location.origin + '/share-flight/' + this.$route.params.comparisonId
			}
		},
		created() {
			this.comparisonCheckAvailability();
			this.getComparison();
		},
		methods: {
			comparisonCheckAvailability() {
				comparisonCheckAvailability({
					type: 'flight',
					orderId: this.$route.query.orderId,
					storageId: this.$route.query.storageId
				}).then(res => this.check_availability = res.data ?? {});
			},
			getComparison() {
				getComparison(this.$route.params.comparisonId).then(res => this.comparison = res.data ?? {});
			},
			openDetails(item) {
				this.card_details = true;
				this.active_card = item;
			},
			openOffer({code}) {
				this.card_details = false;
				this.$router.push({
					name: "flights-offer",
					params: {orderId: this.comparison.orderId, storageId: this.comparison.storageId, code: code, lang: this.$route.params.lang},
					query: {source: this.$route.query.source}
				})
			},
			backPage() {
				this.$router.push({
					name: "flights-search",
					params: {orderId: this.comparison.orderId, storageId: this.comparison.storageId, lang: this.$route.params.lang},
					query: {source: this.$route.query.source}
				})
			}
		}
	}
</script>
